import { getEmptyApplicationScopes } from '../../application/service/application_scope_service';
import { Scopes } from '../model/Scopes';

export function getEmptyFrameworkScopes(scopes: Scopes): Scopes {
    return {
        ...scopes,
        manager: {
            customerId: [],
        },
    };
}

export function getEmptyScopes(): Scopes {
    let scopes = {} as Scopes;
    scopes = getEmptyApplicationScopes(scopes);
    scopes = getEmptyFrameworkScopes(scopes);
    return scopes;
}
